module.exports = __webpack_public_path__ + "static/img/activity_sdy_08-4.93616d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_08-4.jpg
// module id = xMxf
// module chunks = 0